module.exports = __webpack_public_path__ + "img/poster_0.b7ee31de.png";